import axios from "axios";

const API_BASE = import.meta.env.VITE_API_URL || "https://techiohisab.com/api";

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// Barcode API endpoints
export const barcodeAPI = {
  // ✅ Get all barcodes
  getAll: () => api.get("/barcodes"),
  
  // ✅ Get barcode by ID
  getById: (id) => api.get(`/barcodes/${id}`),
  
  // ✅ Create new barcode
  create: (data) => api.post("/barcodes", data),
  
  // ✅ Update barcode
  update: (id, data) => api.put(`/barcodes/${id}`, data),
  
  // ✅ Delete barcode
  delete: (id) => api.delete(`/barcodes/${id}`),
  
  // ✅ Get barcodes by category
  getByCategory: (category) => api.get(`/barcodes/category/${category}`),
  
  // ✅ Search barcodes
  search: (query) => api.get(`/barcodes/search?q=${encodeURIComponent(query)}`),
  
  // ✅ Get barcode statistics
  getStats: () => api.get("/barcodes/stats"),
};

export default api;
